import ENV from "@config/env";

export const getImgSrc = (path: string) => {
  return ENV.CLIENT_ID ? `/${ENV.CLIENT_ID}${path}` : `${path}`;
};
